import React from 'react';
import * as S from './ButtonGroup.styled';
export const ButtonGroup = ({ space = 'small', justify = 'left', align, direction = 'row', fullWidth = false, children, }) => {
    return (React.createElement(S.Group, { "$justify": justify, "$align": align, "$direction": direction, "$fullWidth": fullWidth, "$space": space }, children));
};
